import { showSuccessfullyDeletedToast } from 'pages/ProgramDetails/utils';
import { useMutation, useQueryClient } from 'react-query';
import { useSearchParams } from 'react-router-dom';
import { MILESTONE_TRACKER_ID_PARAM } from 'routes/navigators';
import { queryKeys } from 'services/constants';
import { deleteMilestoneTracker } from 'services/milestoneTrackers/requests';
import { Callback } from 'types/helpers';
import { errorHandler } from 'utils/errorHandler';

export const useDeleteMilestoneTracker = (uuid: string, onSuccess?: Callback) => {
  const queryClient = useQueryClient();

  const [searchParams, setSearchParams] = useSearchParams();

  const { mutateAsync, isLoading } = useMutation(deleteMilestoneTracker, {
    mutationKey: queryKeys.deleteMilestoneTracker,
    onSuccess: async () => {
      await queryClient.invalidateQueries(queryKeys.getMilestoneTrackers);
      showSuccessfullyDeletedToast();
      onSuccess?.();

      // If user is in detail page -> go back
      if (searchParams.get(MILESTONE_TRACKER_ID_PARAM) === uuid) {
        searchParams.delete(MILESTONE_TRACKER_ID_PARAM);
        setSearchParams(searchParams);
      }
    },
    onError: errorHandler,
  });

  return {
    isLoading,
    deleteMilestoneTracker: () => mutateAsync(uuid),
  };
};
